import { Component, h, Element, Prop } from '@stencil/core';
import { JackeryRating as _JackeryRating } from '../jackery-rating/jackery-rating';
import ImgPreviewer from "../../utils/img-previewer/index"
import {CommentItem} from "../../common/interface"
import { getLocaleComponentStrings } from "../../utils/locale";

@Component({
  tag: 'jackery-comment-item',
  styleUrl: 'jackery-comment-item.css',
  shadow: true,
})
export class JackeryCommentItem {
  strings: any;
  @Element() element: HTMLElement;
  @Prop() commentItem: CommentItem = {
    name: '',
    email: '',
    rating: 0,
    comment: '',
    imageUrls: [],
    date: ''
  };

  async componentWillLoad(): Promise<void> {
    this.strings = await getLocaleComponentStrings(this.element);
  }

  componentDidLoad() {
    (this.commentItem.imageUrls && this.commentItem.imageUrls.length > 0) && new ImgPreviewer('#image_gallery__review', {
      fillRatio: 0.7,
      imageZoom: {
        step: 1
      },
      i18n: {
        RESET: this.strings.reset,
        ROTATE_LEFT: this.strings.rotate_left,
        ROTATE_RIGHT: this.strings.rotate_right,
        CLOSE: this.strings.close,
        NEXT: this.strings.next,
        PREV: this.strings.prev
      },
      style: {
        modalOpacity: 0.8
      },
      bubblingLevel: 1,
      root: this.element.shadowRoot
    } as any)
  }
  render() {
    return (
      <div class="comment-item-wrapper">
        <div class="rating-content"><jackery-rating score={this.commentItem.rating} /></div>
        <div class="comment" innerHTML={`<pre>${this.commentItem.comment}</pre>`}></div>
        <div class="reviews-info">
          <span class="user_name">{this.commentItem.name}</span>
          <span class="verified_user">Verified</span>
          <img class="verified_img" src="https://areviewsapp.com/img/verified.png" alt="verify"></img>
          <span class="comment_time">{this.commentItem.date}</span>
        </div>

        {this.commentItem.imageUrls.length > 0 && <div class="image_gallery" id="image_gallery__review">
          {this.commentItem.imageUrls.map(item => (
              <div class="image_gallery_item"><img src={item} alt={this.commentItem.comment} /></div>
            ))}
        </div>}
      </div>
    );
  }
}
